// Controlled vocabularies for the Family Case Management module (PROMPT 8)
import { SERVICE_LANES } from "@/config/resources";
import { URGENCY_LEVELS, RELATIONSHIPS } from "@/config/leadOptions";

export { SERVICE_LANES, URGENCY_LEVELS, RELATIONSHIPS };

// "Current Step" vocabulary (caring language for pipeline stage)
export const CASE_STATUSES = [
  { value: "new", label: "New", tone: "khaki", group: "Intake" },
  { value: "intake_in_progress", label: "Intake in progress", tone: "sky", group: "Intake" },
  { value: "waiting_on_family", label: "Waiting on family", tone: "amber", group: "Intake" },
  { value: "consultation_booked", label: "Free consultation booked", tone: "sky", group: "Consultation" },
  { value: "consultation_completed", label: "Free consultation completed", tone: "navy", group: "Consultation" },
  { value: "plan_created", label: "Plan created", tone: "navy", group: "Active service" },
  { value: "active_service", label: "Active service", tone: "navy", group: "Active service" },
  { value: "partner_assigned", label: "Partner assigned", tone: "sky", group: "Active service" },
  { value: "vendor_assigned", label: "Vendor assigned", tone: "sky", group: "Active service" },
  { value: "deal_in_progress", label: "Deal in progress", tone: "navy", group: "Active service" },
  { value: "waiting_on_documents", label: "Waiting on documents", tone: "amber", group: "Waiting" },
  { value: "waiting_on_decision_maker", label: "Waiting on decision maker", tone: "amber", group: "Waiting" },
  { value: "completed", label: "Completed", tone: "green", group: "Closing" },
  { value: "closed", label: "Closed", tone: "green", group: "Closing" },
  { value: "follow_up_nurture", label: "Follow-up / nurture", tone: "gray", group: "Closing" },
];

export const REVENUE_TYPES = [
  { value: "referral_fee", label: "Referral fee" },
  { value: "commission", label: "Commission" },
  { value: "service_fee", label: "Service fee" },
  { value: "retainer", label: "Retainer" },
  { value: "other", label: "Other" },
];

export const REVENUE_STATUSES = [
  { value: "potential", label: "Potential", tone: "khaki" },
  { value: "quoted", label: "Quoted", tone: "amber" },
  { value: "won", label: "Won", tone: "green" },
  { value: "invoiced", label: "Invoiced", tone: "sky" },
  { value: "paid", label: "Paid", tone: "green" },
  { value: "lost", label: "Lost", tone: "red" },
];

export const COMMUNICATION_TYPES = [
  { value: "call", label: "Phone call" },
  { value: "email", label: "Email" },
  { value: "sms", label: "Text / SMS" },
  { value: "meeting", label: "Meeting" },
  { value: "voicemail", label: "Voicemail" },
  { value: "note", label: "Internal note" },
];

export const DIRECTIONS = [
  { value: "outbound", label: "Outbound" },
  { value: "inbound", label: "Inbound" },
];

// "How they found us" (caring language for lead source)
export const HOW_FOUND_OPTIONS = [
  { value: "website", label: "Website" },
  { value: "referral", label: "Referral" },
  { value: "phone", label: "Phone call" },
  { value: "event", label: "Event" },
  { value: "trilogy", label: "Trilogy" },
  { value: "partner", label: "Partner" },
  { value: "social", label: "Social media" },
  { value: "search", label: "Online search" },
  { value: "other", label: "Other" },
];

export const TONE = {
  red: { bg: "rgba(156,30,34,0.10)", color: "#9C1E22", border: "rgba(156,30,34,0.24)" },
  amber: { bg: "rgba(183,121,31,0.14)", color: "#9A6516", border: "rgba(183,121,31,0.30)" },
  sky: { bg: "rgba(155,185,206,0.25)", color: "#1C4358", border: "rgba(155,185,206,0.45)" },
  navy: { bg: "rgba(28,67,88,0.10)", color: "#1C4358", border: "rgba(28,67,88,0.20)" },
  green: { bg: "rgba(47,125,90,0.12)", color: "#256B4B", border: "rgba(47,125,90,0.28)" },
  khaki: { bg: "rgba(196,200,155,0.35)", color: "#5A5E2E", border: "rgba(196,200,155,0.60)" },
  gray: { bg: "rgba(75,85,99,0.10)", color: "#4B5563", border: "rgba(75,85,99,0.22)" },
};

export const labelOf = (arr, val) => arr.find((o) => o.value === val)?.label || (val || "");
export const optOf = (arr, val) => arr.find((o) => o.value === val) || null;
export const toneOf = (arr, val) => TONE[optOf(arr, val)?.tone || "gray"];
